import { lpGetOptionById } from '../re_index';
import { getOptionPass } from '../global_getter';
import { getMaa } from '../../redux/actions/load_contract';
import lpApp from '../../app/lp_app';

/*
* Project: LegalPlace assistant
* File: src/logic/utils/tree_operations.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/


// In this library we'll have some operations like get siblinges, check siblings all are false ....

function getSiblings(v) {
  const parent = getMaa(v);
  if (typeof parent === 'undefined') return [];
  if (parent <= 0) return [];
  if (lpApp.references.options && lpApp.references.getOption(parent)) {
    return lpApp.references.getOption(parent).children;
  }
  return [];
}

export function filterRadios(siblings = []) {
  return siblings.filter(idx => lpApp.references.getOption(idx).meta.type === 'radio');
}

export function checkIfAllFalse(v = [], copy = '') {
  // preparing the ground for multiples

  let nV;
  if (copy && copy.length > 0) nV = v.map(idx => `${idx}_${copy}`);
  else nV = v;
  let result = true;
  nV.forEach((idx) => {
    let s = lpGetOptionById(idx);
    if (typeof s === 'undefined') {
      s = getOptionPass(idx);
    } else {
      s = s.value;
    }
    if (s) result = false;
  });
  // console.log(v, result);
  return result;
}

export function checkUnInitializedSiblings(v, copy) {
  return checkIfAllFalse(filterRadios(getSiblings(v)), copy);
}

/**
 *
 * @param {array} cd
 */
export function areAllMyChildrenHidden(cd) {
  if (typeof cd === 'undefined') return false;
  const cdChildren = cd.children;
  let result = true;

  cdChildren.forEach((idx) => {
    if (lpApp.references.getOption(idx).meta.type !== 'hidden') result = false;
  });
  return result;
}

/**
 *
 * @param {number} id
 */
export function hasEmptyChildren(id) {
  return (id in lpApp.references.options
    && (lpApp.references.getOption(id).children.length === 0
      || areAllMyChildrenHidden(lpApp.references.getOption(id)))
    && lpApp.references.getOption(id).variables.length === 0
    && (!('warning' in window.lpApp.references.getOption(id).meta) || (lpApp.references.getOption(id).meta.warning === ''))
  );
}

window.hasEmptyChildren = hasEmptyChildren;



// WEBPACK FOOTER //
// ./src/logic/utils/tree_operations.js